// @ts-nocheck
import { FC } from 'react';

import { TRelocationOffer } from '../types';
import clsx from 'clsx';
import parse from 'html-react-parser';

import { Accordion, AccordionContent, AccordionSummary } from '@/components/Logic';

import styles from './Block.module.scss';

import IcArrowAccordion from '@/components/Icons/IcArrowAccordion';

const Block: FC<{ offer: TRelocationOffer }> = ({ offer }) => {
  const getListClassesByType = (type: 'disc' | 'decimal') =>
    clsx(styles.description, {
      [styles.disc]: type === 'disc',
      [styles.decimal]: type === 'decimal',
    });

  return (
    <Accordion className={styles.accordion}>
      <AccordionSummary className={styles.header}>
        <span>{offer.name}</span>
        <IcArrowAccordion className={styles.arrow} />
      </AccordionSummary>

      <AccordionContent>
        {offer.descriptions?.map((item, index) => (
          <div key={index} className={styles.body}>
            <div className={styles.top}>
              {item.subtitle && <span className={styles.subtitle}>{item.subtitle}</span>}

              {item?.lines && item?.listType && (
                <ul className={getListClassesByType(item.listType)}>
                  {item.lines.map((line, index) => (
                    <li key={index} className={styles.line}>
                      {parse(line)}
                    </li>
                  ))}
                </ul>
              )}

              {item.hint && <span className={styles.hint}>{item.hint}</span>}
            </div>

            {item.links?.length && (
              <div className={styles.bottom}>
                {item.links.map((link, index) => (
                  <div key={index} className={styles.link}>
                    {link.qr ? <img src={link.qr} alt='QR-код отсутствует' /> : <span></span>}
                    <a href={link.url} target='_blank' rel='noreferrer'>
                      {link.name}
                    </a>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </AccordionContent>
    </Accordion>
  );
};

export default Block;
